const KEY = "biq_token";
const USER_KEY = "biq_user";

export const getToken = () => localStorage.getItem(KEY);

export const getUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY));
  } catch {
    return null;
  }
};

export const setAuth = (token, user) => {
  localStorage.setItem(KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event("biq-auth"));
};

export const setStoredUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
  window.dispatchEvent(new Event("biq-auth"));
};

export const clearAuth = () => {
  localStorage.removeItem(KEY);
  localStorage.removeItem(USER_KEY);
  window.dispatchEvent(new Event("biq-auth"));
};

export const authFetch = (path, opts = {}) => {
  const isForm = opts.body instanceof FormData;
  return fetch(`${process.env.REACT_APP_BACKEND_URL}${path}`, {
    ...opts,
    headers: {
      ...(isForm ? {} : { "Content-Type": "application/json" }),
      ...(opts.headers || {}),
      ...(getToken() ? { Authorization: `Bearer ${getToken()}` } : {}),
    },
  });
};
